module.exports = __webpack_public_path__ + "img/developers-icon-active.7ad2df0e.svg";